export default __webpack_public_path__ + "static/media/ok_space hub logo-13 red.40c19005.png";